import { render } from "./ContentKritik.vue?vue&type=template&id=4b7d7fab&scoped=true"
import script from "./ContentKritik.vue?vue&type=script&lang=js"
export * from "./ContentKritik.vue?vue&type=script&lang=js"

import "./ContentKritik.vue?vue&type=style&index=0&id=4b7d7fab&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7d7fab"]])

export default __exports__